import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MulishRegular from '../assets/fonts/Mulish-Regular.ttf';
// import { StylesProvider } from '@mui/styles';
import {StyledEngineProvider} from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Mulish, Arial, serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Mulish';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: url(${MulishRegular}) format('truetype');
        }
      `,
    },
  },
});

const MaterialUICustomization = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
};

export default MaterialUICustomization;
